import { render, staticRenderFns } from "./RegistroProveedor.vue?vue&type=template&id=6dfb593d&scoped=true&"
import script from "./RegistroProveedor.vue?vue&type=script&lang=js&"
export * from "./RegistroProveedor.vue?vue&type=script&lang=js&"
import style0 from "./RegistroProveedor.vue?vue&type=style&index=0&id=6dfb593d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb593d",
  null
  
)

export default component.exports